import { createFeatureSelector, createSelector } from '@ngrx/store'

import { State } from './preference.state'

export const signaturePreferenceState = createFeatureSelector<State>('signature-preference')

export const selectSignaturePrefLoaded = createSelector(signaturePreferenceState, (state: State) => state.isLoaded)
export const selectSignaturePref = createSelector(signaturePreferenceState, (state: State) => state.preference)
